<script setup lang="ts">
import { Icon, IconSize } from '~/components/icon';
import TickIcon from '~/assets/icons/tick.svg?component';

const props = defineProps<{
  steps: Array<{
    id: number;
    title: string;
    isCompleted: boolean;
  }>;
  currentStep: number;
}>();
</script>

<template>
  <div
    role="group"
    aria-label="progress"
    class="hidden md:flex justify-between items-center pt-12 pb-6"
  >
    <template v-for="(step, index) in props.steps" :key="step.id">
      <div class="inline-flex flex-col items-center py-2 relative">
        <div
          v-if="index === props.currentStep || !step.isCompleted"
          class="size-6 rounded-full"
          :class="
            index === props.currentStep
              ? 'bg-surface border-primary border'
              : 'bg-disabled'
          "
        />
        <Icon
          v-else
          :icon="TickIcon"
          :size="IconSize.MD"
          class="text-on-primary rounded-full"
          :class="index > props.currentStep ? 'bg-disabled' : 'bg-primary'"
        />
        <span class="absolute top-full font-bold text-xs whitespace-nowrap">
          {{ step.title }}
        </span>
      </div>
      <div
        v-if="index < steps.length - 1"
        data-orientation="horizontal"
        role="none"
        class="flex-1 h-px bg-disabled"
      ></div>
    </template>
  </div>

  <div class="md:hidden flex flex-col items-center py-6">
    <div class="flex items-center w-full text-on-background">
      <div
        class="flex-1 h-px bg-disabled"
        :class="{ invisible: props.currentStep === 0 }"
      />

      <div class="size-6 rounded-full border border-primary bg-surface" />

      <div
        class="flex-1 h-px bg-disabled"
        :class="{ invisible: props.currentStep === props.steps.length - 1 }"
      />
    </div>

    <span class="font-semibold text-xs pt-2 text-center">
      {{ props.steps[props.currentStep].title }}
    </span>

    <span class="text-xs pt-1">
      {{ props.currentStep + 1 }}/{{ props.steps.length }}
    </span>
  </div>
</template>
